module.exports = __webpack_public_path__ + "static/media/logo.e9bc599f.png";